import { Device, FormFactor } from '../../types';
import { detectFormFactor } from '../detectFormFactor';
import { detectOrientation } from '../detectOrientation';
import { detectOS } from '../detectOs';
import { isIE } from '../isIE';
import { isPWA } from '../isPWA';
import { updatePageType } from '../updatePageType';

export const detectDevice = (screenType: FormFactor): Device => ({
  ...detectFormFactor(),
  ...detectOrientation(),
  ...detectOS(),
  ...updatePageType(screenType),
  isPWA: isPWA(),
  isIE: isIE()
});
